import { Link, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  privacyPolicy,
  superStudyParty,
  termsOfUse,
} from "../services/Messages";

export const Footer = () => {
  return (
    <section className="pt-5 pb-5">
      <Grid container justifyContent="center" spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography align="center">
            &copy;{" "}
            <Link
              color="grey.900"
              underline="hover"
              href="https://superstudyparty.com"
              target="_blank"
              rel="noreferrer"
            >
              {superStudyParty}
            </Link>{" "}
            {new Date().getFullYear()}
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography align="right">
            <Link
              color="grey.900"
              underline="hover"
              href="https://superstudyparty.com/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              {privacyPolicy}
            </Link>
          </Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography align="left">
            <Link
              color="grey.900"
              underline="hover"
              href="https://superstudyparty.com/terms-of-use/"
              target="_blank"
              rel="noreferrer"
            >
              {termsOfUse}
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </section>
  );
};
